import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { forwardRef, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

const DialogDelete = forwardRef(({ selectedItems, handleDelete, label = "name", title = "Are you sure you want to delete?" }, ref) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  useImperativeHandle(ref, () => ({
    open: () => setOpen(true),
    close: () => setOpen(false),
  }));

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleCancel}>
      <DialogTitle>
        <Typography variant="Dialog Title">{t("Confirm Delete")}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="Dialog Content">{t(title)}</Typography>
        {selectedItems.map((s, i) => (
          <Box key={i} sx={{ display: "flex", justifyContent: "right" }}>
            <Typography variant="Dialog Content">{s?.[label]}</Typography>
          </Box>
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} variant="outlined">
          {t("Cancel")}
        </Button>
        <Button
          onClick={() => {
            handleDelete(selectedItems);
            setOpen(false);
          }}
          color="error"
          variant="contained">
          {t("Delete")}
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default DialogDelete;
